import buildComponent from './utils/build-component';
import checkIntersection from './utils/check-intersection';

export default (nameSpace, selector) => buildComponent({
  nameSpace,
  selector,
  initState: {
    isInView: false,
    firstImageIsLoaded: false,
    activeImage: null,
  },
  initFunction: ($el, params) => {
    const $images = $el.querySelectorAll(`.${nameSpace}__image`);
    const $imageWrapper = $el.querySelector(`.${nameSpace}__image-wrapper`);
    let INTERVAL_DURATION = (1000 * Math.random() + 2000);

    //
    // Methods
    //

    function initCarousel() {
      params.setState({ activeImage: 0 });
      setInterval(() => {
        params.setState((prevState) => ({ 
          activeImage: ((prevState.activeImage + 1) % $images.length)
        }));
      }, INTERVAL_DURATION);
    }

    //
    // Life Cycle
    //

    params.onStateUpdate((newState, prevState) => {
      if (!prevState.isInView && newState.isInView) {
        import(`./block-img-load`).then(module => {
          [...$images].forEach(($image, index) => {
            setTimeout(() => {
              if ($image.src && index === 0) {
                params.setState({ firstImageIsLoaded: true })
              } else {
                if (index === 0) {
                  $image.Component['block-img-load'].addObserver((state) => state.isLoaded && params.setState({ firstImageIsLoaded: true }));
                }
                $image.Component['block-img-load'].setSrc();
              }
            }, 0)
          })
        })
      }

      if (!prevState.firstImageIsLoaded && newState.firstImageIsLoaded) {
        $imageWrapper.classList.add(`${nameSpace}__image-wrapper--is-loaded`);
        initCarousel();
      }

      if (prevState.activeImage !== newState.activeImage) {
        [...$images].forEach(($image, index) => {
          if (index === newState.activeImage) {
            $image.classList.add(`${nameSpace}__image--is-active`)
          } else {
            $image.classList.remove(`${nameSpace}__image--is-active`)            
          }
        })
      }
    });

    //
    // Procedures
    //

    checkIntersection($el, () => {
      params.setState({ isInView: true });
    })

    //
    // Listeners / Observers
    //


    //
    // Public API
    //

    return {
    };
  }
});



// WEBPACK FOOTER //
// ./src/scripts/editorial-box.js